import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit{
  
  @Input() 
   status: string
   header: string;
   body: string;

  constructor(
    protected ref : NbDialogRef<CustomDialogComponent>
  ) { }
  
  ngOnInit(): void {
      
  }
  
  setIcon(status) {
    if(status === "danger") {
      return "close-circle-outline";
    } else if(status === "warning"){
      return "alert-circle-outline";
    } else if(status === "info") {
      return "info-outline";
    } else if(status == "success") {
      return "checkmark-circle-2-outline";
    } else {
      return "info-outline";
    }
  }
  
  dismiss() {
    this.ref.close({event : false});
  }

}
